/**
 * @generated SignedSource<<fffe371b75d3aaf16677d8d964c54b5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StartContentNodeInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type NavigateDirectToQuestionsAdvanceTreeButton_StartContentNodeMutation$variables = {
  input: StartContentNodeInput;
};
export type NavigateDirectToQuestionsAdvanceTreeButton_StartContentNodeMutation$data = {
  readonly LearnV2: {
    readonly startContentNode: {
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type NavigateDirectToQuestionsAdvanceTreeButton_StartContentNodeMutation = {
  response: NavigateDirectToQuestionsAdvanceTreeButton_StartContentNodeMutation$data;
  variables: NavigateDirectToQuestionsAdvanceTreeButton_StartContentNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "StartContentNodePayload",
        "kind": "LinkedField",
        "name": "startContentNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NavigateDirectToQuestionsAdvanceTreeButton_StartContentNodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NavigateDirectToQuestionsAdvanceTreeButton_StartContentNodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cc331014af9e437ef94ebaff41e6e5ec",
    "id": null,
    "metadata": {},
    "name": "NavigateDirectToQuestionsAdvanceTreeButton_StartContentNodeMutation",
    "operationKind": "mutation",
    "text": "mutation NavigateDirectToQuestionsAdvanceTreeButton_StartContentNodeMutation(\n  $input: StartContentNodeInput!\n) {\n  LearnV2 {\n    startContentNode(input: $input) {\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c3bbce6f9382d8d713bfc1d93071c9f";

export default node;
